import querystring from 'querystring';

/**
 * @deprecated use useRouter instead
 * @example
 * router.replace({ query }, undefined, { shallow: true });
 *
 * @param {*} pathname is url webpage. Ex. /home /home/my-course.
 * @param {*} searchState is a query string. Ex. { a: 'bb', b: true }.
 */
export const replaceUrl = (pathname: string, searchState: any) => {
  let currentPathname = pathname || window.location.pathname;

  if (searchState) {
    currentPathname += `?${querystring.stringify(searchState)}`;
  }
  window.history.replaceState('', '', currentPathname);
};

export const getEndpointDecryptImageIdentity = (userIdentityImageValidationId: number) =>
  `v1/users/user-identity-image-validation/${userIdentityImageValidationId}/decryption-image`;

export const getEndpointAdminDecryptImageIdentity = (userId: number, userIdentityImageValidationId: number) =>
  `v1/manage/users/${userId}/user-identity-image-validation/${userIdentityImageValidationId}/decryption-image`;

export const getAcademicLandingPageUrl = (universitySlug: string): string => `/academic/${universitySlug}`;

export const getDegreeLandingPageUrl = (universitySlug: string, degreeFriendlyUrl: string): string =>
  `/academic/${universitySlug}/degree/${degreeFriendlyUrl}`;
